export { LabResultsOverview } from './LabResultsOverview';
